import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef, EventEmitter,
    Input, OnChanges,
    OnDestroy,
    OnInit, Output,
    ViewChild,
} from '@angular/core';
import {MatButtonToggleChange} from '@angular/material/button-toggle';
import {MatSelectChange} from '@angular/material/select';
import {ActivatedRoute, Router} from '@angular/router';
import {UnitPublicService} from 'app/services/public/unit-public.service';
import {UserService} from 'app/services/user.service';
import {StylingUtils} from 'app/shared/styling-utils';
import _, {filter, forEach} from 'lodash';
import {Location} from '@angular/common';

import {
    BehaviorSubject,
    combineLatest,
    debounceTime, distinct,
    fromEvent, of,
    Subject,
    takeUntil,
} from 'rxjs';
import {StorageLocationService} from "../../../modules/admin/services/storage-location.service";
import {FuseConfirmationService} from '../../../../@fuse/services/confirmation';
import {TranslocoService} from '@ngneat/transloco';
import {formatOpeningHours} from '../../opening-hours';
import {ViewportService} from 'app/services/viewport.service';

@Component({
    selector: 'app-direct-booking',
    templateUrl: './direct-booking.component.html',
    styleUrls: ['./direct-booking.component.scss'],
})
export class DirectBookingComponent
    implements OnInit, AfterViewInit, OnDestroy {
    @Input() pretitle = '';
    @Input() title = '';
    @Input() locationId = '';

    @ViewChild('buildingPlanImg') svgView: any;
    @ViewChild('search') input: ElementRef;

    selectedLocation: any;
    formatOpeningHours = formatOpeningHours;
    units: any = [];
    locations: any[] = [];
    // Gefilterte Optionen fürs Standort-Autocomplete (per Texteingabe durchsuchbar)
    filteredLocations: any[] = [];
    loggedIn$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    mobile: boolean = false;
    mobileDisplay: 'list' | 'layout' = 'list';
    // Sortier-Dropdown ist standardmäßig eingeklappt (dezenter Filter-Button)
    showSort: boolean = false;
    // Aufgeklappte Einheiten-Karten (Beschreibung & Abmaße sichtbar), pro Unit-Id
    listUnits: any = [];
    highlightItem;
    private COLOR_OCCUPIED: string = 'gray';
    private COLOR_FREE: string = StylingUtils.getPrimaryColor();
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    loading = true;

    filters: {
        sortBy$: BehaviorSubject<string>;
        query$: BehaviorSubject<string>;
        hideBooked$: BehaviorSubject<boolean>;
    } = {
        sortBy$: new BehaviorSubject(''),
        query$: new BehaviorSubject(''),
        hideBooked$: new BehaviorSubject(true),
    };

    sortCategories: any[] = [
        {
            id: '1',
            i18nKey: 'sort-by-unit-number',
            field: 'name:asc',
        },
        {
            id: '2',
            i18nKey: 'sort-by-size-asc',
            field: 'squareMeter:asc',
        },
        {
            id: '3',
            i18nKey: 'sort-by-size-desc',
            field: 'squareMeter:desc',
        },
        {
            id: '4',
            i18nKey: 'sort-by-price-asc',
            field: 'minPrice:asc',
        },
        {
            id: '5',
            i18nKey: 'sort-by-price-desc',
            field: 'minPrice:desc',
        },
    ];

    constructor(
        private userService: UserService,
        private unitService: UnitPublicService,
        private router: Router,
        private route: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        private location: Location,
        private locationService: StorageLocationService,
        private _fuseConfirmationService: FuseConfirmationService,
        private translocoService: TranslocoService,
        private viewport: ViewportService
    ) {
    }

    startBooking(unit: any): void {
        if (unit.status === 'occupied' || unit.status === 'other') return;

        this.router.navigate(['/home/booking-steps'], {
            queryParams: { unitId: (unit as any)._id},
        });
    }

    ngOnInit(): void {
        this.viewport.isMobile$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((mobile) => (this.mobile = mobile));
        this.userService.isLoggedIn().then((data) => {
            this.loggedIn$.next(data);
        });

        combineLatest([
            this.filters.sortBy$,
            this.filters.query$,
            this.filters.hideBooked$,
        ]).subscribe(([sortBy, query, hideBooked]) => {
            // Reset the filtered courses
            this.listUnits = filter(this.units, {status: 'free'});
            // Filter by search query
            if (query && query !== '') {
                const filerData = query?.split(':');
                this.listUnits = this.listUnits.filter((unit) =>
                    this.queryFilter(
                        unit[filerData[0]],
                        filerData[1],
                        parseFloat(filerData[2]),
                    ),
                );
            }

            if (hideBooked) {
                this.listUnits = this.listUnits.filter(
                    (unit) => unit.status !== 'FREE',
                );
            }
            // Filter by category
            if (sortBy !== '') {
                const orderByData = sortBy.split(':');
                this.listUnits = _.orderBy(
                    this.listUnits,
                    orderByData[0],
                    orderByData[1] as any,
                );
            }
        });

        this.filters.sortBy$.next('name:asc');
    }

    ngAfterViewInit(): void {
        this.determineAndSetLocation();
    }

    determineAndSetLocation(): void {
        this.unitService.getLocations().subscribe((data: any) => {
            this.locations = data;
            this.filteredLocations = data;

            if (this.locationId) { //passedin via input
                const foundLocation = _.find(this.locations, {_id: this.locationId});
                if (foundLocation) {
                    this.setLocation(foundLocation);
                } else {
                    this.setLocation(this.locations[0]);
                }
            } else {
                this.locationService.getCurrentLocation().pipe(distinct()).subscribe((location) => {
                    if (location) {
                        this.setLocation(location);
                    } else {
                        this.setLocation(this.locations[0]);
                    }
                });

            }
        });
    }

    scrollToUnitList(unit): void {
        // Karten-Liste: die passende Kachel sanft in den sichtbaren Bereich holen
        document
            .getElementById(`unit-card-${unit?._id}`)
            ?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    calculateSquareMeter(width, length): string {
        return (width * length).toPrecision(2);
    }

    getCheapestPrice(prices: any): any {
        const calculatedPrices = prices.map((price) => {
            return price.price - price.price * (price.discount / 100);
        });
        return _.min(calculatedPrices);
    }

    login(): void {
        this.userService.login().then(() => {
            this.userService.isLoggedIn().then((data) => {
                console.log('logged IN', data);
                this.loggedIn$.next(data);
            });
        });
    }

    openInfoDialog(additioalInfo: string){
        const dialogRef = this._fuseConfirmationService.open({
            message: additioalInfo,
            title: this.translocoService.translate('booking-location-message'),
            icon: {
                show: false
            },
            actions: {
                cancel: {
                    show: false,
                },
                confirm: {
                    label: this.translocoService.translate('button-close'),
                    color: 'primary'
                }
            }
        });

        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    doNothing(): void {
    }

    queryFilter(value1, sign, value2): boolean {
        switch (sign) {
            case 'gte':
                return value1 >= value2;
            case 'lte':
                return value1 <= value2;
            case 'gt':
                return value1 > value2;
            case 'lt':
                return value1 < value2;
            case 'eq':
                return value1 === value2;
            default:
                return value1 === value2;
        }
    }

    logout(): void {
        this.userService.logout();
    }

    navigateToUserProfile(): void {
        this.router.navigate(['/user']);
    }

    filterLocations(query: string): void {
        const q = (query || '').toLowerCase();
        this.filteredLocations = this.locations.filter((l) => l?.name?.toLowerCase().includes(q));
    }

    onLocationInput(event: any): void {
        this.filterLocations(event?.target?.value);
    }

    onLocationFocus(inputEl: HTMLInputElement): void {
        // Beim Fokussieren die volle Liste zeigen und Text markieren, damit man direkt weitertippen kann
        this.filterLocations('');
        inputEl?.select();
    }

    onLocationOptionSelected(location: any, inputEl: HTMLInputElement): void {
        this.setLocation(location);
        if (inputEl) {
            inputEl.value = location?.name || '';
        }
    }

    setLocation(location: any): void {
        if (!location) {
            return;
        }

        if(location?.value){
            const bla = this.locations.find(_location => _location?._id === location?.value);
            location = bla;
        }

        if (this.locationId !== location._id) {
            this.locationId = location._id;
            this.locationService.setCurrentLocation(location);
        }

        // URL immer mit dem Standort synchron halten, damit sie teilbar bleibt
        this.location.replaceState('/home/booking', `location=${location._id}`);

        this.selectedLocation = location;
        this.setupUnits(this.selectedLocation);
        this.unitService
            .getFloorplan(location.floorPlan)
            .subscribe((result) => {
                this.setSvgData(result);
                this.setUpSvgs();
            });
    }

    setupUnits(location): void {
        this.unitService.getUnitsForLocation(location._id).subscribe({
            next: (data) => {
                _.forEach(data, (unit) => {
                    Object.assign(unit, {
                        minPrice: this.getCheapestPrice((unit as any).prices),
                        squareMeter: this.calculateSquareMeter(
                            (unit as any).width,
                            (unit as any).length,
                        ),
                    });
                });
                this.units = data;
                this.listUnits = filter(this.units, {status: 'free'});

                this.route.queryParamMap.subscribe((_data: any) => {
                    this.filters.query$.next(_data?.params?.filter);
                });
                this.setUpSvgs();
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    switchView(event: MatButtonToggleChange): void {
        this.mobileDisplay = event?.value;
        if (this.mobileDisplay === 'layout') {
            this.setLocation(this.selectedLocation);
        }
    }

    filterByCategory(change: MatSelectChange | any): void {
        this.filters.sortBy$.next(change.value);
    }

    setSvgData(data: any): void {
        if (!this.svgView) return;
        this.svgView.nativeElement.innerHTML = data;
    }

    highlightUnit(unit: any): void {
        document
            .getElementById(`${unit.name}`)
            ?.setAttribute('fill', '#BBF7D0');
    }

    unhighlightUnit(unit: any): void {
        document
            .getElementById(`${unit.name}`)
            ?.setAttribute('fill', this.getFillColor(unit));
        this.highlightItem = null;
    }

    getFillColor(unit: any): string {
        if (unit?.status === 'free') {
            return this.COLOR_FREE;
        } else if (unit?.status === 'occupied') {
            return this.COLOR_OCCUPIED;
        } else {
            return this.COLOR_OCCUPIED;
        }
    }

    setUpSvgs(): void {
        forEach(this.units, (unit) => {
            document
                .getElementById(`${unit.name}`)
                ?.addEventListener('mouseover', (e: any) => {
                    this.highlightItem = unit;
                    this.scrollToUnitList(unit);
                    e.target.setAttribute('fill', '#BBF7D0');
                });

            document
                .getElementById(`${unit.name}`)
                ?.addEventListener('mouseout', (e: any) => {
                    let color = this.getFillColor(
                        this.units.find(
                            (unit) => unit.name === e.target.id.split('-')[0],
                        ),
                    );
                    e.target.setAttribute('fill', color);
                    this.highlightItem = null;
                });

            document
                .getElementById(`${unit.name}`)
                ?.addEventListener('click', (e: any) => {
                    this.startBooking(
                        _.find(this.units, {name: e.target.id.split('-')[0]}),
                    );
                });
        });
        this.setOccupiedStorages();
    }

    setOccupiedStorages(): void {
        this.units.forEach((unit) => {
            if (unit?.status === 'free') {
                document
                    .getElementById(`${unit.name}`)
                    ?.setAttribute('fill', this.COLOR_FREE);
            } else if (unit?.status === 'occupied') {
                document
                    .getElementById(`${unit.name}`)
                    ?.setAttribute('fill', this.COLOR_OCCUPIED);
            } else {
                document
                    .getElementById(`${unit.name}`)
                    ?.setAttribute('fill', this.COLOR_OCCUPIED);
            }
        });
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

}
